export default "__VITE_ASSET__CxbVNDFE__"